<template>
  <div>
    <div class="header-container">
      <div class="header-logo">
        <div>
          <router-link :to="{name: 'Home'}" class="td-none">
            <img class="header-img" src="/static/images/a4works_logo_header.png" alt="エーフォーワークス">
          </router-link>
        </div>
        <div class="bars-icon-container" @click="menuToggle">
          <I i="bars"/>
        </div>
      </div>
      <div class="header-menu" @click="menuClose" :class="menuState">
        <!--<router-link :to="{name: 'Home'}" class="item" >-->
          <!--<div class="menu">HOME</div>-->
        <!--</router-link>-->
        <router-link :to="{name: 'Information'}" class="item">
          <div class="menu">INFORMATION</div>
        </router-link>
        <router-link :to="{name: 'Works'}" class="item">
          <div class="menu">WORKS</div>
        </router-link>
        <router-link :to="{name: 'Corporate'}" class="item">
          <div class="menu">CORPORATE</div>
        </router-link>
        <router-link :to="{name: 'Recruit'}" class="item">
          <div class="menu">RECRUIT</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    menuToggle: function () {
      if (this.isMenuOpen) {
        this.isMenuOpen = false
      } else {
        this.isMenuOpen = true
      }
    },
    menuClose: function () {
      this.isMenuOpen = false
    }
  },
  computed: {
    menuState: function () {
      if (this.isMenuOpen) {
        return ''
      } else {
        return 'display-none'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  // 801以上
  @media screen and (min-width: 801px) {
    .header-container {
      line-height: 50px;
      height: 50px;
      background: #fff;
      width: 100%;
      text-align: left;
      display: flex;
      align-items: flex-end;

      .header-logo {
        height: 50px;

        .header-img {
          height: 40px;
          margin: 10px 0 0 8px;
        }
      }

      .header-menu {
        width: 100%;
        margin-left: 20px;
        display: flex;
        justify-content: space-around;

        .item {
          font-size: 16px;
          line-height: 25px;
          padding-top: 10px;
          text-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
        }

      }

    }

    .menu {
      width: 194px;
      text-align: center;
    }

    .bars-icon-container {
      display: none;
    }
  }

  // 800まで
  @media screen and (max-width: 800px) {
    .header-container {
      line-height: 50px;
      background: #fff;
      width: 100%;

      .header-logo {
        height: 50px;
        display: flex;
        justify-content: space-between;
        .header-img {
          height: 40px;
          margin: 10px 0 0 8px;
        }
      }

      .bars-icon-container {
        font-size: 30px;
        margin-right: 10px;
        cursor: pointer;
      }

      .header-menu {
        width: 100%;
        .item {
          display: block;
          padding-right: 20px;
          background: #555;
          text-align: right;
          font-size: 16px;
          text-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
        }

        a.item:link,
        a.item:visited {
          color: #fff;
        }

        a.item:hover {
          color: #fff;
          background: #777;
        }

        a.item:active {
          color: #fff;
          background: #999;
        }
      }

    }
  }

  a.td-none:link,
  a.td-none:visited,
  a.td-none:active,
  a.td-none:hover {
    border-bottom: none;
  }

  a.item:link,
  a.item:visited {
    border-bottom: 2px solid #888;
  }

  a.item:hover {
    background: #fafafa;
    border-bottom: 2px solid #333;
  }

  a.item:active {
    background: #fff;
    border-bottom: 2px solid #eee;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue